import { useHookstate } from "@hookstate/core";
import { Page } from "../../../../types";
import { readerDataStore } from "../../../../hookstate/readerDataStore";

export function useReleasePagesData() {
  const releasePagesData = useHookstate(readerDataStore.releasePagesData).get({
    noproxy: true,
  });

  const setReleasesPagesData = (data: Page[]) => {
    readerDataStore.releasePagesData.set(data);
  };

  return { releasePagesData, setReleasesPagesData };
}
